import ReportsListReducers from './List/store/slice'
import ReportFormReducers from './Form/store/slice'
import FormTypesListReducers from './FormTypes/store/slice'

export default {
  ...ReportsListReducers,
  ...ReportFormReducers,
  ...FormTypesListReducers,
}

